export default {
  persons: [],
  types: [{id: 1, name: 'Aluno'}, {id: 2, name: 'Professor'}, {id: 3, name: 'TAE'}, {id: 4, name: 'Terceirizado'}],
  fingers: []
}
